import React from 'react';

import { Box, Typography } from '@mui/material';

import { parseNullableValue } from '@hrlogics/helper-utils';
import { SxProp } from '@hrlogics/react-helper-types';

import { usePeoById } from 'src/hooks/peo';

type PeoControlledByInfoProps = {
  peoId?: string;
  isPartnership: boolean;
};

export const PeoControlledByInfo: React.FC<PeoControlledByInfoProps> = ({
  peoId,
  isPartnership,
}) => {
  const { peo } = usePeoById(peoId);

  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Typography variant="body2" sx={typographyStyles}>
        {isPartnership ? 'Partnership' : 'PEO'}
      </Typography>

      {peo?.peoPayrollProvider && (
        <Typography variant="body2" sx={typographyStyles}>
          PEO PP: {parseNullableValue(peo.peoPayrollProvider.displayName)}
        </Typography>
      )}
    </Box>
  );
};

const typographyStyles: SxProp = theme => ({
  color: theme.palette.text.secondary,
});
